module.exports = __webpack_public_path__ + "img/space.d7458cce.jpg";